import PropTypes from 'prop-types';

import Chart from '../../charts/Chart';
import 'highcharts/modules/wordcloud';

import { THEMES_DARK, useTheme, WORD_CLOUD_COLORS } from '../../helpers';
import { buildWordCloudChartOptions } from './utilities/helpers';

import styles from '../Chart/_index.module.scss';

const WordCloud = ({ data }) => {
  const theme = useTheme();
  const wordCloudColors =
    theme === THEMES_DARK.value ? WORD_CLOUD_COLORS.dark : WORD_CLOUD_COLORS.light;
  const wordCloudFreqMin = 7;

  const filteredData = data
    .filter((point) => point.weight >= wordCloudFreqMin)
    .map((point, index) => ({
      ...point,
      color: wordCloudColors[index % wordCloudColors.length],
    }));

  const chartOptions = buildWordCloudChartOptions({ data: filteredData, tooltipEnabled: true });

  return (
    <Chart
      chartTitle={`Word Cloud - ${filteredData.length} Words`}
      className={styles['chart-word-cloud']}
      options={chartOptions}
    />
  );
};

WordCloud.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      weight: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default WordCloud;
